/**
 * Helpers shared by the portal's pages. Loaded on every portal page as part of the bundle, so everything
 * here only defines functions and does nothing on its own.
 */

/**
 * Brings the portal's fixed toast into view.
 *
 * The toast is pinned to the top of the portal document, and the portal is normally an iframe sized to its
 * own content - so "fixed" means the top of the frame, which can sit well above whatever the customer is
 * looking at on the merchant's page. On a long page nothing happens visually for them, and the action looks
 * ignored.
 *
 * pw.js already answers 'forced-scroll' by scrolling the parent to the frame's top plus an offset, which is
 * how addresses-edit.blade.php brings its missing-answers heading into view. -60 leaves the same gap the
 * auto-scroll path leaves. Outside an iframe the message goes nowhere, and the scrollIntoView below is what
 * does the work.
 */
function scrollPortalFrameIntoView() {
    try {
        window.parent.postMessage(
            {
                source: "paywhirl",
                frame: window.name,
                method: "forced-scroll",
                offset: -60,
            },
            "*",
        );
    } catch (e) {
        // A parent that refuses postMessage is not a reason to lose the message the customer needs.
    }

    var toast = document.querySelector(".messenger-message");

    if (toast && toast.scrollIntoView) {
        toast.scrollIntoView({ block: "nearest" });
    }
}
